<template>
  <v-dialog :value="show" max-width="500" @input="$emit('close')">
    <v-card>
      <v-card-title class="headline">Anmeldung erfolgreich!</v-card-title>
      <v-card-text v-if="result">
        <p><strong>Team:</strong> {{ result.team }}</p>
        <p><strong>Anzahl Teilnehmer*innen:</strong> {{ result.participants ? result.participants.length : 0 }}</p>
        <p v-if="result.shirts && result.shirts.length > 0">
          <strong>Anzahl T-Shirts:</strong> {{ result.shirts.length }}
        </p>
        <v-divider class="my-3"></v-divider>
        <h3>Zu zahlen: {{ result.totalPayment }}€</h3>
        <p v-if="result.totalPayment > 0">
          Bitte überweist den Betrag mit dem Verwendungszweck:<br>
          <strong>{{ result.paymentToken }}</strong>
        </p>
        <v-divider class="my-3"></v-divider>
        <p><strong>Angemeldete Teilnehmer*innen:</strong></p>
        <ul>
          <li v-for="p in result.participants" :key="p.id">
            {{ p.firstName }} - Startnummer: {{ p.startNumber }}
          </li>
        </ul>
        <template v-if="result.selfServiceToken">
          <v-divider class="my-3"></v-divider>
          <p class="mb-2">
            <strong>Startnummern später herunterladen:</strong> Diesen persönlichen Link bitte aufbewahren
            (nicht öffentlich teilen).
          </p>
          <v-btn :href="bulkSelfServiceLink" color="brown" outlined small target="_blank" rel="noopener">
            Zur Download-Seite
          </v-btn>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Schliessen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SuccessDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object,
      default: null
    }
  },
  computed: {
    bulkSelfServiceLink() {
      if (!this.result || !this.result.selfServiceToken) return '#';
      return `/#/bulk-me?token=${this.result.selfServiceToken}`;
    }
  }
}
</script>
